module.exports = __webpack_public_path__ + "img/appetizer.20886446.png";